import {
  Box,
  Button,
  Card,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  LinearProgress,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Typography,
} from '@mui/material';
import { FundProps, GetFundsListResponseBody } from '../../redux-store/types/funds';
import {
  Distributor,
  getDistributorsListForFilters,
  getRMsList,
  RMListFilter,
} from '../../redux-store/actions';
import { useEffect, useState } from 'react';
import { getFundsList } from '../../redux-store/actions/funds';
import { useDispatch, useSelector } from 'react-redux';
import {
  distributorWisecommitmentAmount,
  monthwiseCommitmentAmount,
  monthwiseOnboardingSummary,
  onboardingSummary,
} from '../../redux-store/actions/application';
import {
  OnboardingFilterType,
  RMType,
  distributorWisecommitmentType,
  monthwiseCommitmentAmountType,
  monthwiseOnboardingSummaryType,
} from '../../redux-store/types/api-types';

import { FilterDatePicker } from '../investors/filters';
import { getFromDate } from '../Reports/report-utils';
import UseRadioGroup from '../../lib/formik/Radio';
import { USER_ROLES } from '../../utils/constant';
import { green } from '@mui/material/colors';
import { formatCurrency } from '../../utils/utilityFunctions';
import { RootStateType } from '../../redux-store/reducers';
import { setDashboardFilters } from '../../redux-store/reducers/onboardingdata';

const todayEndTime = new Date();
todayEndTime.setHours(23, 59, 59);

export const initialFilters: OnboardingFilterType = {
  distributorId: null,
  schemeId: '',
  rmId: null,
};

type OnboardingDashboardTypes = {
  funds: FundProps[];
  distributors: Distributor[];
};

export default function OnboardingDashboard({
  funds,
  distributors,
}: OnboardingDashboardTypes): JSX.Element {
  // const [funds, setFunds] = useState<FundProps[]>([]);
  // const [distributors, setDistributors] = useState<Distributor[]>([]);
  const dispatch = useDispatch();
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  // const [currency, setcurrency] = useState('INR');
  const [filters, setFilters] = useState<OnboardingFilterType>(initialFilters);

  const [rmsList, setRmsList] = useState<RMType[]>([]);

  const onboardingSummaryData = async (filters: OnboardingFilterType) => {
    try {
      (await dispatch(onboardingSummary(filters))) as unknown as OnboardingFilterType;
      (await dispatch(
        monthwiseOnboardingSummary(filters)
      )) as unknown as monthwiseOnboardingSummaryType;
      if (USER_ROLES.AMC_ADMIN === role) {
        (await dispatch(
          distributorWisecommitmentAmount(filters)
        )) as unknown as distributorWisecommitmentType;
      }
      (await dispatch(
        monthwiseCommitmentAmount(filters)
      )) as unknown as monthwiseCommitmentAmountType;
    } catch (e) {
      console.error(e);
    }
  };
  const isDistributorFilterVisible = [
    USER_ROLES.AMC_ADMIN,
    USER_ROLES.SUPER_ADMIN,
    USER_ROLES.RM,
  ].includes(role);
  const isRMFilterVisible = [USER_ROLES.SUPER_ADMIN, USER_ROLES.AMC_ADMIN].includes(role);
  useEffect(() => {
    onboardingSummaryData(initialFilters);
    (async () => {
      if (isRMFilterVisible) {
        const rms = (await dispatch(getRMsList())) as unknown as RMType[]; // Example API
        setRmsList(rms);
      }
    })();
  }, []);

  console.log(rmsList);
  return (
    <>
      <Grid item xs={12} sm={12} mb={3}>
        <Card raised={true} sx={{ minHeight: 100, p: 2, width: '100%', boxSizing: 'border-box' }}>
          {/* <Typography align="center" fontWeight={700} fontSize={18}>
            Onboarding Dashboard
          </Typography> */}
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={4}>
              <Box sx={{ display: 'flex', flexDirection: 'column', padding: '0px' }}>
                <Typography
                  sx={{
                    fontSize: { lg: 18, xs: 12 },
                    fontWeight: 600,
                    display: 'flex',
                    alignItems: 'center',
                  }}>
                  Select Scheme
                </Typography>
                <Select
                  style={{
                    width: '100%',
                    height: '44px',
                    padding: '0 10px',
                    borderRadius: '6px',
                    fontSize: '15px',
                  }}
                  value={filters.schemeId}
                  onChange={({ target: { value } }) => {
                    setFilters({ ...filters, schemeId: value });
                  }}>
                  {funds?.map((fund) => (
                    <MenuItem key={Number(fund?.id)} value={fund?.id}>
                      {fund?.schemeName}
                    </MenuItem>
                  ))}
                </Select>
              </Box>
            </Grid>
            {isDistributorFilterVisible && (
              <>
                <Grid item xs={12} sm={6} md={4}>
                  <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography
                      sx={{
                        fontSize: { lg: 18, xs: 12 },
                        fontWeight: 600,
                        display: 'flex',
                        alignItems: 'center',
                      }}>
                      Select Distributor
                    </Typography>
                    <Select
                      style={{
                        width: '100%',
                        height: '44px',
                        padding: '0 10px',
                        borderRadius: '6px',
                        fontSize: '15px',
                      }}
                      value={filters.distributorId}
                      onChange={({ target: { value } }) => {
                        setFilters((prev) => ({
                          ...prev,
                          distributorId: value === '' ? null : Number(value),
                        }));
                      }}>
                      {distributors.map((d) => (
                        <MenuItem key={d.id} value={d.id}>
                          {d.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </Box>
                </Grid>
              </>
            )}
            {isRMFilterVisible && (
              <>
                <Grid item xs={12} sm={6} md={4}>
                  <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography
                      sx={{
                        fontSize: { lg: 18, xs: 12 },
                        fontWeight: 600,
                        display: 'flex',
                        alignItems: 'center',
                      }}>
                      Select RM
                    </Typography>
                    <Select
                      style={{
                        width: '100%',
                        height: '44px',
                        padding: '0 10px',
                        borderRadius: '6px',
                        fontSize: '15px',
                      }}
                      value={filters?.rmId ?? ''}
                      onChange={({ target: { value } }) => {
                        setFilters((prev) => ({
                          ...prev,
                          rmId: value === '' ? null : Number(value),
                        }));
                      }}>
                      {rmsList.map((rm: RMType) => (
                        <MenuItem key={rm.id} value={rm.id}>
                          {rm.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </Box>
                </Grid>
              </>
            )}
          </Grid>
          <Grid container justifyContent="flex-end" spacing={2} mt={1}>
            <Grid item>
              <Button
                variant="contained"
                size="small"
                color="primary"
                onClick={async () => {
                  const resetFilters = { ...initialFilters };
                  setFilters(resetFilters);
                  await onboardingSummaryData(initialFilters);
                }}
                sx={{
                  height: 28,
                  px: 1.5,
                  py: 0,
                  minHeight: 0,
                  fontSize: 12,
                  lineHeight: 1,
                  textTransform: 'none',
                }}>
                Reset Filters
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                size="small"
                color="primary"
                type="submit"
                onClick={async () => {
                  dispatch(setDashboardFilters(filters));
                  await onboardingSummaryData(filters);
                }}
                sx={{
                  height: 28,
                  px: 1.5,
                  py: 0,
                  minHeight: 0,
                  fontSize: 12,
                  lineHeight: 1,
                  textTransform: 'none',
                }}>
                Apply Filter
              </Button>
            </Grid>
          </Grid>
        </Card>
      </Grid>
    </>
  );
}
